<template>
    <div class="FaqWrap" id="faq">
        <h2 class="headline headline--bigger">{{ i18n.mate_otazky }}</h2>
        <div class="Delimiter"></div>
        <div
                v-for="(item, index) in items"
                @click="showQuestion(index)"
                :class="{'FaqWrap-item': true, 'is-active' : activeQuestionIndex == index}"
        >
            <h3>{{ item.question[lang] }}</h3>
            <div class="FaqWrap-item__content" v-html="item.answer[lang]"></div>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            items: Array
        },
        data: function () {
            return {
                activeQuestionIndex: null,
	              lang: document.documentElement.lang,
                i18n: i18n
            };
        },
        methods: {
            showQuestion: function (index) {
                if(this.activeQuestionIndex == index)
					this.activeQuestionIndex = null;
				else
                	this.activeQuestionIndex = index;
            }
        },
    };
</script>
